export default __webpack_public_path__ + "static/media/blog-04.344e72ef.jpg";